module.exports = __webpack_public_path__ + "img/Ce.b786eb3e.png";